/**
 * Paginado en el cliente de la mesa de trabajo. Los endpoints de cashflow
 * devuelven la lista completa (no paginan), así que acá sólo se corta lo que
 * se muestra; los totales del pie se siguen calculando sobre todo.
 */

export const PAGE_SIZES = [25, 50, 100] as const;
export const ALL_ROWS = 0;
export const DEFAULT_PAGE_SIZE = 25;

/** Cantidad de páginas; con tamaño 0 ("todas") es una sola. */
export const pageCount = (total: number, pageSize: number): number => {
    if (pageSize <= 0) return 1;
    return Math.max(1, Math.ceil(total / pageSize));
};

/** Mantiene la página dentro de rango cuando cambia el filtro o el tamaño. */
export const clampPage = (page: number, total: number, pageSize: number): number =>
    Math.min(Math.max(1, page), pageCount(total, pageSize));

export const pageSlice = <T>(items: T[], page: number, pageSize: number): T[] => {
    if (pageSize <= 0) return items;
    const current = clampPage(page, items.length, pageSize);
    return items.slice((current - 1) * pageSize, current * pageSize);
};

/** "1–25 de 132" para la barra del paginador. */
export const pageRangeLabel = (total: number, page: number, pageSize: number): string => {
    if (total === 0) return '0 registros';
    if (pageSize <= 0) return `${total} registros`;
    const current = clampPage(page, total, pageSize);
    const from = (current - 1) * pageSize + 1;
    const to = Math.min(total, current * pageSize);
    return `${from}–${to} de ${total}`;
};

/** Cuántas contrapartes se muestran plegadas antes de "ver todas". */
export const PARTIES_PREVIEW = 8;
